<template>
	<!-- 风险承受能力最低类别 - 风险不匹警示函 - 投资者确认书-->
	<div  v-if="isShowModel" class="model-container animated-5 fadeIn">
		<!-- 风险承受能力最低类别 -->
        <div v-if="isShowMiniRisk" class="model-box posi-relative" >
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<span class="mdl-title"> 风险等级不匹配提示 </span>
				<span></span>
			</p>
			<!-- 主要内容 -->
			<div class="model-content">
				<div>
                    您当前风险等级为C1(风险承受能力最低类别)，属于最低风险承受能力的投资者，根据适当性匹配原则和相关法规要求仅可购买我司风险等级为R1(低风险)的产品，无法购买风险等级为R2(中低风险)、R3(中风险)、R4(中高风险)、R5(高风险)的产品。
                </div> 
				<div class=" btn-box flex-jf-btw">
                    <btn-middle @click="$emit('modelHandle')" classCpt="ccBtn btn-free">放弃购买</btn-middle>
                    <btn-middle  classCpt="okBtn" @click="$emit('modelHandle'),$router.push({path:'/fengxianceping'}),$tools.setSession('Fxpc_url',urlpathStart)">
                        去风险评测
                    </btn-middle>
				</div>
			</div>
		</div>
        <!-- 风险不匹警示函 -->
        <div v-if="isShowFXBPPJSH"  class="model-box posi-relative" >
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<span class="mdl-title"> 风险等级不匹配提示 </span>
				<span></span>
			</p>
			<!-- 主要内容 -->
			<div class="model-content">
				<div>
                    经核实，您申请购买的产品或服务等级为{{fundRiskInfo}}，您当前的风险等级{{userRiskInfo}}，不属于最低风险承受能力的投资者，不存在违反准入要求的情况。根据适当性匹配原则，该产品或者服务高于您风险承受能力，我司特此向您警示：购买该产品/服务，可能导致您承担超出自身承受能力损失以及不利后果。请您认真考虑相应风险，审慎决定购买该产品或服务。
                </div> 
				<div class=" btn-box flex-jf-btw">
                    <btn-middle @click="$emit('modelHandle',false)" classCpt="ccBtn btn-free">放弃购买</btn-middle>
                    <btn-middle @click="isShowFXBPPJSH=false,isShowTZZQRS=true" classCpt="okBtn">仍要继续</btn-middle>
				</div>
			</div>
		</div>
        <!-- 投资者确认书 -->
        <div v-if="isShowTZZQRS" class="model-box posi-relative" >
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<span class="mdl-title"> 投资者确认书 </span>
				<span></span>
			</p>
			<!-- 主要内容 -->
			<div class="model-content">
				<div>
                本人已收到贵司出具的《风险不匹配警示函》，对于本人申请购买产品/服务风险等级高于本人风险承受能力情况已知悉，
                并且已充分了解该产品/服务的风险特征和可能的不利后果。经本人审慎考虑，仍坚持申请购买该产品/服务，
                并自愿承担由此可能产生的一切不利后果和损失。该销售机构及工作人员在销售过程中，
                不存在直接或间接主动向本人推荐该产品/服务的行为。
                </div> 
				<div class=" btn-box flex-jf-btw">
                    <btn-middle @click="$emit('modelHandle',false)" classCpt="btn-free">放弃购买</btn-middle>
                    <btn-middle @click="$emit('modelHandle',true)">仍要继续</btn-middle>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性
		props:['fundRisk','userRisk','miniRisk','FXBPPJSH','linkTo','urlpathStart'],
		mounted(){
            
		},
		data(){
			return{
                isShowMiniRisk:false, //-- 是否显示 风险承受能力最低类别
                isShowFXBPPJSH:false, //-- 是否显示风险不匹配警示函
                isShowTZZQRS:false, //-- 是否显投资者确认书
                userRiskInfo:'',
                fundRiskInfo:'',
                // urlpathStart:'',
			}
        },		
        watch:{
            userRisk(){
                if(this.userRisk == '1'){
                    this.userRiskInfo = "C1(安全型)";
                }else if(this.userRisk == '2'){
                    this.userRiskInfo = "C2(保守型)";
                }else if(this.userRisk == '3'){
                    this.userRiskInfo = "C3(稳健型)";
                }else if(this.userRisk == '4'){
                    this.userRiskInfo = "C4(积极型)";
                }else if(this.userRisk == '5'){
                    this.userRiskInfo = "C5(进取型)";
                }
            },
            fundRisk(){
                if(this.fundRisk == 'R1'){
                    this.fundRiskInfo = "R1(低风险)";
                }else if(this.fundRisk == 'R2'){
                    this.fundRiskInfo = "R2(中低风险)";
                }else if(this.fundRisk == 'R3'){
                    this.fundRiskInfo = "R3(中风险)";
                }else if(this.fundRisk == 'R4'){
                    this.fundRiskInfo = "R4(中高风险)";
                }else if(this.fundRisk == 'R5'){
                    this.fundRiskInfo = "R5(高风险)";
                }else{
                   this.fundRiskInfo = this.fundRisk;
                }
            },
        },
        computed:{
            //是否显示 模态框
            isShowModel(){
                //初始化
                this.isShowMiniRisk = false; //-- 是否显示 风险承受能力最低类别
                this.isShowFXBPPJSH = false; //-- 是否显示风险不匹配警示函
                this.isShowTZZQRS = false; //-- 是否显投资者确认书
                //判断显示类别
                if(this.miniRisk){ //-- 风险承受能力最低类别
                    this.isShowMiniRisk = this.miniRisk;
                }
                if(this.FXBPPJSH ){ //-- 显示 风险不匹配警示函
                    this.isShowFXBPPJSH = this.FXBPPJSH;
                } 
                return this.miniRisk || this.FXBPPJSH;
            }
        }, 
		methods:{
             
		}
	}
</script>

<style scoped lang='less'>
    .model-container{
        display: block;
        .model-box{
            width:20rem;
            .model-content{ 
                padding: .9rem 1rem; 
                >div:first-child{ 
                    font-size: .8rem; 
                    color: #666;
                }
                .btn-box{
                    padding-top:.8rem;
                    button{
                       width: 8.5rem;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/publicCpts/modelConfirmFXBPPJSH.vue